const customSelectBox = () => {
    var customSelect = $(document).find('.custom-mv-select');
    customSelect.each(function () {
        var thisCustomSelect = $(this);
        if (!thisCustomSelect.attr('data-custom')) {
            thisCustomSelect.attr('data-custom', true);
            var isRequired = thisCustomSelect.find('select').attr('required');

            var options = thisCustomSelect.find('option');
            var optionsSelected = thisCustomSelect.find('option:selected').text();
            var optionValue = thisCustomSelect.find('option:selected').attr('id');
            var sortText = $("#sort-order").attr('aria-label');
            var selectedItem;
            if (optionsSelected) {
                if (thisCustomSelect.hasClass('sortOrderList')) {
                    selectedItem = $('<div></div>', {
                        class: 'selected-item',
                    })
                        .appendTo(thisCustomSelect)
                        .html(`${sortText}:<b>${optionsSelected}</b>`);
                } else {
                    selectedItem = $('<div></div>', {
                        class: 'selected-item',
                    })
                        .appendTo(thisCustomSelect)
                        .html(`<span class="option-selected">${optionsSelected}</span>`);
                }
            } else {
                selectedItem = $('<div></div>', {
                    class: 'selected-item',
                })
                    .appendTo(thisCustomSelect)
                    .html('<span style="color:#757575">Please select</span>');
            }

            if (isRequired !== '' && optionValue === '') {
                thisCustomSelect.addClass('is-invalid');
            }

            var allItems = $('<div></div>', {
                class: 'all-items all-items-hide',
            }).appendTo(thisCustomSelect);

            $('body').on('click', () => {
                if ($('.all-items:not(.all-items-hide)').length) {
                    thisCustomSelect.find('.all-items').addClass('all-items-hide');
                    thisCustomSelect.find('.selected-item').removeClass('arrowanim');
                }
            });

            options.each(function () {
                var that = $(this);
                var optionText = that.text();
                if (that.val() !== '') {
                    $('<div></div>', {
                        class: 'custom-item',
                        value: that.val(),
                        on: {
                            click() {
                                var selectedOptionText = that.text();
                                sessionStorage.setItem('sortSelected', selectedOptionText);
                                selectedItem.text(selectedOptionText).removeClass('arrowanim');
                                allItems.addClass('all-items-hide');
                                thisCustomSelect.find('option:selected').removeAttr('selected');
                                var sortText = $("#sort-order").attr('aria-label');
                                if (that.parents('select#sort-order').length) {
                                    // added to make selected item bold on every time user click
                                    $('.sortOrderList .all-items .custom-item').removeClass('selectedOption');
                                    $('.sortOrderList .all-items .custom-item').each(function () {
                                        let isSelected = $(this).text().trim() === selectedOptionText.trim();
                                        if (isSelected) $(this).attr('style', 'font-weight:600').addClass('selectedOption');
                                        else $(this).attr('style', 'font-weight:400');
                                    });
                                    $.spinner().start();
                                    let url = $('#customerNoUrl').val();
                                    let customerId = "";
                                    $.ajax({
                                        url,
                                        type: 'get',
                                        success(data) {
                                            if (data.customerId) {
                                                customerId = data.customerId;
                                            }
                                        },
                                        error() {
                                            console.error('Error fetching content:', error);
                                        },
                                    });
                                    updateSortUrlState(that.val());
                                    $.ajax({
                                        url: that.val(),
                                        data: { selectedUrl: that.val() },
                                        method: 'GET',
                                        success(response) {
                                            $('.product-grid').empty().html(response);
                                            var filterData = $($.parseHTML(response)).filter(".searchAjaxGAFilter");
                                            var filterDataGA = JSON.parse(filterData.text());
                                            if (filterDataGA) {
                                                filterDataGA.userID = customerId;
                                                window.dataLayer.push(filterDataGA);
                                            }
                                            selectedItem.html(`${sortText}:<b>${selectedOptionText}</b>`).removeClass('arrowanim');
                                            $.spinner().stop();                                           
                                        },
                                        error() {
                                            $.spinner().stop();
                                        },
                                    });
                                }
                            },
                        },
                    })
                        .appendTo(allItems)
                        .text(optionText);
                }
            });
            // added to make selected item bold on initial render
            $('.sortOrderList .all-items .custom-item').each(function () {
                let isSelected = $(this).text().trim() === optionsSelected.trim();
                if (isSelected) $(this).attr('style', 'font-weight:600').addClass('selectedOption');
                else $(this).attr('style', 'font-weight:400');
            });
        }
    });

    var selectedItem = $('.selected-item');
    var allItems = $('.all-items');

    selectedItem.on('click', function (e) {
        var currentSelectedItem = $(this);

        var currentAllItems = currentSelectedItem.next('.all-items');

        allItems.not(currentAllItems).addClass('all-items-hide');
        selectedItem.not(currentSelectedItem).removeClass('arrowanim');

        currentAllItems.toggleClass('all-items-hide');
        currentSelectedItem.toggleClass('arrowanim');

        e.stopImmediatePropagation();
    });

    $(document).on('click', () => {
        var opened = $('.all-items:not(.all-items-hide)');
        var index = opened.parent().index();

        customSelect
            .eq(index)
            .find('.all-items')
            .addClass('all-items-hide');
        customSelect
            .eq(index)
            .find('.selected-item')
            .removeClass('arrowanim');
    });
};

$(() => {
    customSelectBox();
});

/**
 * Get URL params
 * @param {string} url - url
 * @param {string} param - param
 * @return {string|null} param value
 */
function getUrlParameterValue(url, param) {
    var index = url.indexOf('?');
    if (index > 0) {
        var u = url.substring(index + 1).split('&');
        var params = new Array(u.length);

        for (var i = 0; i < u.length; i++) {
            params[i] = u[i].split('=');
            if (params[i][0] === param) {
                return params[i][1];
            }
        }
    }
    return null;
}

/**
 * Update URL params
 * @param {string} url - url
 * @param {string} param - param
 * @param {string} value - param
 * @return {string} updated url
 */
function updateUrlParameter(url, param, value) {
    var index = url.indexOf('?');
    if (index > 0) {
        var u = url.substring(index + 1).split('&');
        var params = new Array(u.length);
        var found = false;
        for (var i = 0; i < u.length; i++) {
            params[i] = u[i].split('=');
            if (params[i][0] === param) {
                params[i][1] = value;
                found = true;
            }
        }

        if (!found) {
            params.push(new Array(2));
            params[params.length - 1][0] = param;
            params[params.length - 1][1] = value;
        }

        var res = `${url.substring(0, index + 1) + params[0][0]}=${params[0][1]}`;
        for (var i = 1; i < params.length; i++) {
            res += `&${params[i][0]}=${params[i][1]}`;
        }
        return res;
    }
    return `${url}?${param}=${value}`;
}

/**
 * Push selected sort rule into the current browser URL
 * @param {string} sortUrl - selected sort option URL
 * @return {undefined}
 */
function updateSortUrlState(sortUrl) {
    if (!sortUrl) {
        return;
    }

    var selectedSortRule = getUrlParameterValue(sortUrl, 'srule');

    if (selectedSortRule) {
        var newUrl = updateUrlParameter(window.location.href, 'srule', selectedSortRule);
        window.history.pushState({}, null, newUrl);
    }
}


module.exports = {
    customSelectBox,
};
